import {
  parseToolCallMetadata,
  type ToolCall,
} from '~/components/v2/components/workspace/workspace-agent-panel/schemas/toolCallMetadata';
import { type WorkspaceAgentMessage } from '~/components/v2/components/workspace/workspace-agent-panel/types/workspaceAgentMessage';

export const buildWorkspaceAgentToolCallById = (messages: readonly WorkspaceAgentMessage[]): Map<string, ToolCall> => {
  const toolCallById = new Map<string, ToolCall>();

  for (const message of messages) {
    if (message.role !== 'toolCall') {
      continue;
    }

    for (const toolCall of parseToolCallMetadata(message.metadata)) {
      toolCallById.set(toolCall.id, toolCall);
    }
  }

  return toolCallById;
};
